import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';

import PendingCustomersListQuery from './PendingCustomersListQuery';
import LastRegisteredCustomersListQuery from './LastRegisteredCustomersListQuery';
import PendingCustomersActivationListQuery from './PendingCustomersActivationListQuery';
import ProsizerAdvert from './ProsizerAdvert/ProsizerAdvert';
import './dashboard.scss';
import SidebarGuide from './../navigation/SidebarGuide/SidebarGuide';
import { dashboardSidebarGuideLinks } from './../navigation/SidebarGuide/SidebarGuideLinks';
import AlertPopup from './../../ui/AlertPopup/AlertPopup';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <Container fluid>
        <Row>
          <ProsizerAdvert />
          <Col md={12} lg={6} className="mobile-helper">
            <AlertPopup align="vertical" />
            <PendingCustomersListQuery />
          </Col>
          <Col md={12} lg={6} className="mobile-helper">
            <PendingCustomersActivationListQuery />
          </Col>
          <Col md={12} lg={12} className="mobile-helper">
            <LastRegisteredCustomersListQuery />
          </Col>
        </Row>
      </Container>

      <SidebarGuide items={ dashboardSidebarGuideLinks } />
    </div>
  );
};

export default Dashboard;
